import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";

// Guardrail-spine badge: any AI-origin value shows this until a human verifies it.
export function AiSuggestedBadge({ className = "", label = "AI-suggested · unverified" }) {
  return (
    <Badge data-testid="ai-suggested-badge"
      className={`rounded-full border border-violet-300 bg-violet-50 text-violet-700 text-[10px] font-medium ${className}`}>
      <Sparkles className="w-3 h-3 mr-1" />{label}
    </Badge>
  );
}
